module.exports = __webpack_public_path__ + "static/media/farshad.7d816680.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/farshad.png
// module id = 113
// module chunks = 0